import { createUseStyles, Styles } from 'react-jss';

export default createUseStyles((theme: Styles) => ({
  field: {
    marginTop: 10
  }
}));
